export default __webpack_public_path__ + "static/media/CardOneImg.94b70f98.svg";